"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ServiceHelp32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M11.293 23.293A1 1 0 0112 23h14c1.11 0 2-.892 2-2V8a2 2 0 00-2.008-2H6.008A2.002 2.002 0 004 8v13c0 1.11.891 2 1.997 2h2.006a1 1 0 011 1l-.001 1.584 2.29-2.291zM25.993 5A3 3 0 0129 8v13c0 1.657-1.334 3-3 3H12l-3.294 3.294c-.39.39-.706.263-.705-.303L8.002 25l.001-1H5.997A2.994 2.994 0 013 21V8c0-1.657 1.343-3 3.008-3h19.984zM16.5 20a.5.5 0 100 1 .5.5 0 000-1zm0-12c-2.215 0-4 1.872-4 4.17a.5.5 0 001 0c0-1.756 1.349-3.17 3-3.17s3 1.414 3 3.17c0 1.19-.453 1.798-1.502 2.405-.14.081-.623.345-.65.36-.978.547-1.41 1.033-1.348 1.868v1.161a.5.5 0 001 0v-.887l-.001-.31c-.027-.367.166-.584.837-.959.018-.01.51-.279.662-.367 1.33-.77 2.002-1.673 2.002-3.27C20.5 9.871 18.715 8 16.5 8z", className: "service-help-32_svg__path-1" }))); };
var StyledServiceHelp32 = styled_components_1.default(ServiceHelp32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledServiceHelp32;
var templateObject_1;
//# sourceMappingURL=ServiceHelp32.js.map